/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { SysqueElectricalState } from '@hcworkspace/sysque/toolbelt/feature';
import { Observable } from 'rxjs';
import { SystemInfo } from '../system-info';
import { SysQueCategoryOperationsResult, SysQueSystemsOperationsResult } from '../../../../../feature/src/lib/models/sysque-systems-operations';
import { TabDescription } from '../tab-description';

export interface ISystemCategoryOptionsFacade {
    requestSystemOptions(nameOfRequest: string, systemName: string, selectedSystemOrCategory: string, oldSystemName?: string): Observable<SysQueSystemsOperationsResult>;
    requestCategoryOptions(requestName: string, newCategoryName: string, systemName: string, oldCategoryName?: string): Observable<SysQueCategoryOperationsResult>;
    closeWindow(): void;
    windowResize(height: number): void;    
    updateSystemInfo(systems: SystemInfo[]): void;
    getSystemState(): SysqueElectricalState;
    updateStateService(categories: TabDescription[]): void
}

export const SYSTEM_CATEGORY_OPTIONS_FACADE_TOKEN = new InjectionToken<ISystemCategoryOptionsFacade>('SYSTEM_CATEGORY_OPTIONS_FACADE_TOKEN');
